import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Spin } from 'antd';
import axios from 'axios';
import config from '../../config';
import DashboardAdmin from './DashboardAdmin';
import DashboardOperations from './DashboardOperations';
import DashboardSecretaire from './DashboardSecretaire';
import './homeDashboard.css';

const DOMAIN = config.REACT_APP_SERVER_DOMAIN;

export default function HomeDashboard() {
  const role = useSelector(s => s.user?.currentUser?.role);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // La secrétaire a sa propre page (DashboardSecretaire) qui gère période et
    // chargement elle-même : aucun appel /operations à faire ici pour elle.
    if (!role || role === 'secretaire') return;

    const endpoint = role === 'admin'
      ? `${DOMAIN}/api/dashboard/admin`
      : `${DOMAIN}/api/dashboard/operations`;

    let cancelled = false;
    setLoading(true);
    setError(null);

    axios.get(endpoint)
      .then(r => { if (!cancelled) { setData(r.data); setLoading(false); } })
      .catch(e => {
        if (!cancelled) {
          const msg = e.response?.status === 403
            ? 'Accès non autorisé à ce tableau de bord.'
            : (e.response?.data?.message || 'Erreur de chargement');
          setError(msg);
          setLoading(false);
        }
      });

    return () => { cancelled = true; };
  }, [role]);

  // Centre de supervision dédié au rôle secrétaire (périodes J/J-1/J-2/J-3,
  // par-livreur, finance sous permission creances.voir, timeline).
  if (role === 'secretaire') return <DashboardSecretaire />;

  if (loading) return (
    <div className="hd-loading">
      <Spin size="large" tip="Chargement du tableau de bord…" />
    </div>
  );

  if (error) return (
    <div className="hd-error">
      <div className="hd-error__icon">⚠</div>
      <div className="hd-error__msg">{error}</div>
    </div>
  );

  if (!data) return null;

  if (role === 'admin') return <DashboardAdmin data={data} />;
  return <DashboardOperations data={data} />;
}
